import { render, staticRenderFns } from "./edit_uuid.vue?vue&type=template&id=5371ad6c&scoped=true&"
import script from "./edit_uuid.vue?vue&type=script&lang=js&"
export * from "./edit_uuid.vue?vue&type=script&lang=js&"
import style0 from "./edit_uuid.vue?vue&type=style&index=0&id=5371ad6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5371ad6c",
  null
  
)

export default component.exports